import { SearchOrigins, SearchUrlParamKeys } from 'search-gateway-client';

const CONVERSATIONAL_SEARCH_PATH = '/ai/conv-search/new';

export default function getConversationalSearchUrl(
    prompt: string,
    searchOrigin: SearchOrigins,
    contentClass?: string,
): string {
    const params = new URLSearchParams({
        [SearchUrlParamKeys.SEARCH_ORIGIN]: searchOrigin,
        ...(contentClass ? { [SearchUrlParamKeys.CONTENT_CLASS]: contentClass } : {}),
        prompt,
    });
    return `${CONVERSATIONAL_SEARCH_PATH}?${params.toString()}`;
}
